import React from 'react'
import BgGallerie from '../../../assets/pexels-brett-sayles-1340502.jpg'

const Galerie = () => {
    return (
        <div>
            
            <div style={{backgroundImage: `url(${BgGallerie})`, height: 700+'px', width: 100+'%',  backgroundRepeat: 'no-repeat', backgroundPositionY: -300+"px" , left: 0,backgroundSize: 'cover' }} className="text-center h1 bg-secondary text-bordeaux">
                Galerie
            </div>
            
        </div>
    )
}



export default Galerie